/**
 * Generated by orval 🍺
 * Do not edit manually.
 * QPM API
 * OpenAPI spec version: 0.1.0
 */
import {
  useQuery
} from '@tanstack/react-query';
import type {
  QueryFunction,
  QueryKey,
  UseQueryOptions,
  UseQueryResult
} from '@tanstack/react-query';

import type {
  HTTPValidationError,
  SearchInstrumentsParams,
  SymbolSearchResponse
} from '../../models';

import { customMutator } from '../../api.ts';

type AwaitedInput<T> = PromiseLike<T> | T;

      type Awaited<O> = O extends AwaitedInput<infer T> ? T : never;


type SecondParameter<T extends (...args: never) => unknown> = Parameters<T>[1];



const withQueryKey = <T extends object, K>(query: T, queryKey: K): T & { queryKey: K } => {
  const result = { queryKey } as T & { queryKey: K };
  for (const key of Object.keys(query)) {
    // The explicit queryKey always wins, matching the previous
    // `{ ...query, queryKey }` spread where it was set last.
    if (key === 'queryKey') continue;
    Object.defineProperty(result, key, {
      enumerable: true,
      configurable: true,
      get: () => (query as Record<string, unknown>)[key],
    });
  }
  return result;
};

/**
 * @summary Search Instruments
 */
export const searchInstruments = (
    params: SearchInstrumentsParams,
 options?: SecondParameter<typeof customMutator>,signal?: AbortSignal
) => {


      return customMutator<SymbolSearchResponse>(
      {url: `/portfolio/instruments/search`, method: 'GET',
        params, signal
    },
      options);
    }




export const getSearchInstrumentsQueryKey = (params?: SearchInstrumentsParams,) => {
    return [
    `/portfolio/instruments/search`, ...(params ? [params] : [])
    ] as const;
    }


export const getSearchInstrumentsQueryOptions = <TData = Awaited<ReturnType<typeof searchInstruments>>, TError = HTTPValidationError>(params: SearchInstrumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchInstruments>>, TError, TData>, request?: SecondParameter<typeof customMutator>}
) => {

const {query: queryOptions, request: requestOptions} = options ?? {};

  const queryKey =  queryOptions?.queryKey ?? getSearchInstrumentsQueryKey(params);



    const queryFn: QueryFunction<Awaited<ReturnType<typeof searchInstruments>>> = ({ signal }) => searchInstruments(params, requestOptions, signal);





   return  { queryKey, queryFn, ...queryOptions} as UseQueryOptions<Awaited<ReturnType<typeof searchInstruments>>, TError, TData> & { queryKey: QueryKey }
}

export type SearchInstrumentsQueryResult = NonNullable<Awaited<ReturnType<typeof searchInstruments>>>
export type SearchInstrumentsQueryError = HTTPValidationError


/**
 * @summary Search Instruments
 */

export function useSearchInstruments<TData = Awaited<ReturnType<typeof searchInstruments>>, TError = HTTPValidationError>(
 params: SearchInstrumentsParams, options?: { query?:UseQueryOptions<Awaited<ReturnType<typeof searchInstruments>>, TError, TData>, request?: SecondParameter<typeof customMutator>}

 ):  UseQueryResult<TData, TError> & { queryKey: QueryKey } {

  const queryOptions = getSearchInstrumentsQueryOptions(params,options)

  const query = useQuery(queryOptions) as  UseQueryResult<TData, TError> & { queryKey: QueryKey };

  return withQueryKey(query, queryOptions.queryKey);
}






